export default __webpack_public_path__ + "static/media/telegram.bacd96d1.svg";